// extracted by mini-css-extract-plugin
export default {"signatureContainer":"signatureCanvas_signatureContainer__H0r7b","signatureCanvas":"signatureCanvas_signatureCanvas__FMzCb","clearButton":"signatureCanvas_clearButton__yosxA"};